import styles from "./AuthPage.module.scss";
import LoginForm from "../features/auth/LoginForm";
import { HeaderBanner } from "../shared/components/HeaderBanner";
import { Layout } from "../shared/components/Layout";
import { loginBackground, loginCharacter } from "../assets/images";
import PreloadedImage from "../shared/components/PreloadedImage/PreloadedImage";
import { HeaderVariant } from "../shared/components/Header/types";
export default function AuthPage() {
  return (
    <Layout
      background={loginBackground}
      customMainClass={styles.authMain}
      customPlaceholder={styles.placeholder}
      headerVariant={HeaderVariant.Brown20NoneWhiteLogo}
    >
      <PreloadedImage
        src={loginCharacter}
        alt="Альми приветствует вас"
        className={styles.character}
        customContainerClass={styles.imageContainer}
      />
      <div className={styles.content}>
        <HeaderBanner>Привет, Друг! Заходи в гости!</HeaderBanner>
        <LoginForm />
      </div>
    </Layout>
  );
}
